import React, { useState } from 'react';
import { bool } from 'prop-types';
import { BasicScrollImage, TriggerOnScroll } from '../../../elements';
import styles from './Banner.module.scss';

import phoneLeft from '../../../styles/images/phone-1.png';
import phoneLeft2x from '../../../styles/images/phone-1@2x.png';
import phoneLeftDark from '../../../styles/images/phone-1-black.png';
import phoneLeftDark2x from '../../../styles/images/phone-1-black@2x.png';
import banner from '../../../styles/images/img-banner-2.png';
import banner2x from '../../../styles/images/img-banner-2@2x.png';
import bannerDark from '../../../styles/images/img-banner-dark-2.png';
import bannerDark2x from '../../../styles/images/img-banner-dark-2@2x.png';
import phoneRight from '../../../styles/images/phone-2.png';
import phoneRight2x from '../../../styles/images/phone-2@2x.png';
import phoneRightDark from '../../../styles/images/phone-2-black.png';
import phoneRightDark2x from '../../../styles/images/phone-2-black@2x.png';

function BannerImages(props) {
  const { isPageAnimationsUnblocked } = props;
  const [isAnimationEnded, setIsAnimationEnded] = useState(false);

  return (
    <TriggerOnScroll bypass={!isPageAnimationsUnblocked} topOffset="10%" bottomOffset="-5%">
      <div
        className={styles['banner__images-wrapper']}
        onAnimationEnd={() => setIsAnimationEnded(true)}
      >
        <div className={styles.banner__images}>
          <div className={styles.banner__img_left}>
            <BasicScrollImage
              isBasicScrollEnabled={isAnimationEnded}
              imgProps={{
                className: 'vertical-parallax',
                imgData: {
                  '1x': phoneLeft,
                  '2x': phoneLeft2x,
                  alt: 'phone',
                },
                darkImgData: {
                  '1x': phoneLeftDark,
                  '2x': phoneLeftDark2x,
                  alt: 'dark phone',
                },
              }}
              scrollProps={{
                props: {
                  '--ty': {
                    from: '0',
                    to: '-80%',
                  },
                },
              }}
            />
          </div>
          <div className={styles.banner__img_center}>
            <BasicScrollImage
              isBasicScrollEnabled={isAnimationEnded}
              imgProps={{
                className: 'vertical-parallax',
                imgData: {
                  '1x': banner,
                  '2x': banner2x,
                  alt: 'banner',
                },
                darkImgData: {
                  '1x': bannerDark,
                  '2x': bannerDark2x,
                  alt: 'banner dark',
                },
              }}
              scrollProps={{
                props: {
                  '--ty': {
                    from: '0',
                    to: '-30%',
                  },
                },
              }}
            />
          </div>
          <div className={styles.banner__img_right}>
            <BasicScrollImage
              isBasicScrollEnabled={isAnimationEnded}
              imgProps={{
                className: 'vertical-parallax',
                imgData: {
                  className: styles.banner__phone_right,
                  '1x': phoneRight,
                  '2x': phoneRight2x,
                  alt: 'phone right',
                },
                darkImgData: {
                  className: styles.banner__phone_right_dark,
                  '1x': phoneRightDark,
                  '2x': phoneRightDark2x,
                  alt: 'phone right dark',
                },
              }}
              scrollProps={{
                props: {
                  '--ty': {
                    from: '0',
                    to: '-80%',
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
    </TriggerOnScroll>
  );
}

BannerImages.propTypes = {
  isPageAnimationsUnblocked: bool,
};

export default BannerImages;
